import { useQueryClient } from '@tanstack/react-query'
import { useContext, useEffect } from 'react'

import { MODALS_ID, QUERY_KEY } from '../../../constants'

import { ModalContext } from '../../../provider/ModalProvider'

import { useNavigate } from '../../../hooks/useNavigate'

import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

export function SuccessVerificationModal({ redirectUrl }: { redirectUrl?: string }) {
  const { closeModal } = useContext(ModalContext)

  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const close = () => {
    if (redirectUrl) navigate(redirectUrl)
    closeModal(MODALS_ID.SUCCESS_VERIFICATION)
  }

  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: [QUERY_KEY.userInfo] })
  }, [])

  return (
    <Modal id={MODALS_ID.SUCCESS_VERIFICATION}>
      <Text size={16} weight={500} block={true} $textAlign="center">
        휴대폰 번호가 등록되었어요.
      </Text>
      <Modal.Footer>
        {/* TODO: 확인 누른 후 내 정보 페이지로 이동하지 않고 그냥 modal 만 닫히기 */}
        <Button type="primary" onClick={close}>
          확인
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
